import moment from 'moment'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import useConfig from '@/features/configs/useConfig'
import { OfferQuotationStatus } from '@/features/offers/constants'
import useOfferList from '@/features/offers/hooks/useOfferList'
import { authSelector } from '@/stores/auth/authSlice'
import { Flex, Text, VStack } from '@chakra-ui/react'
import BaseOfferTaskWidget from './BaseOfferTaskWidget'
import OfferTaskButton from './OfferTaskButton'
import { OfferBookingStatus } from '@eapproval/offer-shared'
import { ContributorGroupType } from '@/features/contributorGroups/constants'

const OfferMaintenanceTaskWidget = ({ quotationOffers = [], bookingOffers = [] }) => {
  const { user } = useSelector(authSelector)

  const { useFetchMyOffers, useCountOfferMaintenanceSummary } = useOfferList()
  const { useFetchConfigByType } = useConfig()

  const { data: upcomingRenewalOfferCount } = useCountOfferMaintenanceSummary({
    filters: {
      salesResponsible: user?.fullName || '',
      projectEndDate: `to:${moment().add(3, 'M').format('DD-MMM-YYYY')};`,
    },
  })

  const { data: maintenanceViewTeamConfig } = useFetchConfigByType('OFFER_MAINTENANCE_VIEW_TEAM')

  //My Maintenance

  const canViewMyMaintenance = useMemo(() => {
    if (
      !user ||
      !Array.isArray(maintenanceViewTeamConfig?.value) ||
      !Array.isArray(user?.departments) ||
      user.contributorGroup === ContributorGroupType.PROCUREMENT_OFFICER
    ) {
      return false
    }

    return user.departments.some((dept) => maintenanceViewTeamConfig.value.includes(dept))
  }, [maintenanceViewTeamConfig?.value, user])

  if (!canViewMyMaintenance) {
    return <></>
  }

  return (
    <BaseOfferTaskWidget title={'My Maintenance'}>
      <Flex gap="5" direction={['column', 'row']} wrap="wrap">
        <OfferTaskButton
          color="teal"
          buttonText={'Quotation'}
          count={quotationOffers.length}
          link={`/offers/offerMaintenance?salesResponsible=${user.fullName || ''}&status=${Object.values(OfferQuotationStatus).join(',')}`}
          label={
            <VStack>
              {Object.values(OfferQuotationStatus).map((status) => {
                return (
                  <Text key={status}>
                    {status}:{quotationOffers.filter((offer) => offer.status === status).length}
                  </Text>
                )
              })}
            </VStack>
          }
        />

        <OfferTaskButton
          color="blue"
          buttonText={'Booking'}
          count={bookingOffers.length}
          link={`/offers/bookingMaintenance?salesResponsible=${user.fullName || ''}&status=${Object.values(OfferBookingStatus).join(',')}`}
          label={
            <VStack>
              {Object.values(OfferBookingStatus).map((status) => {
                return (
                  <Text key={status}>
                    {status}:{bookingOffers.filter((offer) => offer.status === status).length}
                  </Text>
                )
              })}
            </VStack>
          }
        />
      </Flex>
      <Flex>
        <OfferTaskButton
          color="teal"
          buttonText={'Upcoming 3 months Maintenance Renewal'}
          count={upcomingRenewalOfferCount}
          link={`/offers/maintenanceSummary?&salesResponsible=${user.fullName || ''}&projectEndDate=type__dateBefore--${moment().add(3, 'M').format('DD-MMM-YYYY')}`}
        />
      </Flex>
    </BaseOfferTaskWidget>
  )
}

export default OfferMaintenanceTaskWidget
